// ─── Template : STEPPER ± ─────────────────────────────────────────
// Compteur [−] valeur [＋] + contenu optionnel à droite (aide, aperçu).
//   <Stepper valeur={n} onMoins={…} onPlus={…} apres={<Text>…</Text>} />
import React, { useMemo } from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { useUI } from '../theme/PreferencesUI';

export default function Stepper({ valeur, onMoins, onPlus, apres, style }) {
  const UI = useUI();
  const s = useMemo(() => makeStyles(UI), [UI]);
  return (
    <View style={[s.rangee, style]}>
      <TouchableOpacity style={s.btn} onPress={onMoins} accessibilityLabel="−">
        <Text style={s.btnTxt}>−</Text>
      </TouchableOpacity>
      <Text style={s.val}>{String(valeur)}</Text>
      <TouchableOpacity style={s.btn} onPress={onPlus} accessibilityLabel="＋">
        <Text style={s.btnTxt}>＋</Text>
      </TouchableOpacity>
      {apres}
    </View>
  );
}

const makeStyles = (UI) => StyleSheet.create({
  rangee: { flexDirection: 'row', alignItems: 'center', gap: 8 },
  btn: { width: 32, height: 32, borderRadius: 16, borderWidth: 1, borderColor: UI.champBord, backgroundColor: UI.card, alignItems: 'center', justifyContent: 'center' },
  btnTxt: { fontSize: 17, color: UI.accent, fontWeight: '700' },
  val: { fontSize: 16, fontWeight: '800', color: UI.ink, minWidth: 30, textAlign: 'center' },
});
